import useDeliveryAmountThreshold from '../../../../hooks/order/useDeliveryAmountThreshold';
import useHelpers from '../../../../hooks/utility/useHelpers';
import { WithClassname } from '../../../../types';
import { Alert } from 'antd';
import useStore from '../../../../hooks/context/useStore';
import React from 'react';

export default function DeliveryAmountThreshold({ className }: WithClassname) {
  const { storeData } = useStore();

  const { formatCurrency } = useHelpers();
  const {
    hasDeliveryAmountThreshold,
    isWithinThreshold,
    isWithinMinThreshold,
    isWithinMaxThreshold,
    minThreshold,
    maxThreshold,
  } = useDeliveryAmountThreshold();

  return (
    hasDeliveryAmountThreshold &&
    !isWithinThreshold && (
      <>
        {!isWithinMinThreshold && (
          <Alert
            message={`Delivery not possible. ${storeData.name} has set a minimum basket amount of ${formatCurrency(minThreshold)}`}
            type="error"
            className={className}
          />
        )}
        {!isWithinMaxThreshold && (
          <Alert
            message={`Delivery not possible. ${storeData.name} has set a maximum basket amount of ${formatCurrency(maxThreshold)}`}
            type="error"
            className={className}
          />
        )}
      </>
    )
  );
}
